import { getLocalizerProvider, Localizer } from './localization.service';
export { getLocalizerProvider, Localizer, };
/** Store current Translator as singleton for use outside of components */
let T;
export function l10nTranslations(locale, globals) {
    const provider = getLocalizerProvider(locale, globals);
    return (language) => {
        T = provider(language);
        return T;
    };
}
export function getCurrentTranslations() {
    return T;
}
